import { ref } from 'vue';
import { trpc } from '@/trpc';

export interface ApiKeyStatus {
  hasKey: boolean;
  lastFour: string | null;
}

const status = ref<ApiKeyStatus | null>(null);
let inflight: Promise<ApiKeyStatus> | null = null;

async function fetchStatus(): Promise<ApiKeyStatus> {
  const result = await trpc.getApiKeyStatus.query();
  status.value = result;
  return result;
}

// Returns the cached status if loaded, otherwise fetches once.
// Concurrent callers share the same inflight request.
export async function ensureApiKeyStatus(): Promise<ApiKeyStatus> {
  if (status.value) return status.value;
  if (!inflight) {
    inflight = fetchStatus().finally(() => {
      inflight = null;
    });
  }
  return inflight;
}

// Force-refresh after set/clear.
export async function refreshApiKeyStatus(): Promise<ApiKeyStatus> {
  status.value = null;
  return ensureApiKeyStatus();
}

// Reactive accessor for templates.
export function useApiKeyStatus() {
  return { status, ensureApiKeyStatus, refreshApiKeyStatus };
}
